import { computed, ref } from "vue";

const formatDateForDisplay = (date: Date | null): string | null => {
  if (!date) return null;
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

/**
 * 画面ロジックを扱う composable。
 */
export const useDeliveryRequestSearchForm = () => {
  const now = new Date();
  const nowDate =
    now.getFullYear() +
    "-" +
    ("0" + String(Number(now.getMonth()) + 1)).slice(-2) +
    "-" +
    ("0" + now.getDate()).slice(-2);

  const searchConditionReceptionNo = ref<string | undefined | null>("");
  const searchConditionMemberId = ref<string | undefined | null>(null);
  const searchConditionName = ref<string | undefined | null>(null);
  const searchConditionPhone = ref<string | undefined | null>(null);
  const searchConditionZipCode = ref<string | undefined | null>(null);
  const searchConditionRegisterNo = ref<number | undefined | null>(null);
  const searchConditionReceiptNo = ref<number | undefined | null>(null);

  const ReceptionDateFrom = ref(false);
  const ReceptionDateTo = ref(false);
  const DeliveryDateFrom = ref(false);
  const DeliveryDateTo = ref(false);

  const searchConditionReceptionDateFrom = ref<Date | null>(null);
  const searchConditionReceptionDateTo = ref<Date | null>(
    nowDate ? new Date(nowDate) : null
  );
  const searchConditionDeliveryDateFrom = ref<Date | null>(
    nowDate ? new Date(nowDate) : null
  );
  const searchConditionDeliveryDateTo = ref<Date | null>(
    nowDate ? new Date(nowDate) : null
  );

  const searchConditionReceptionDateFromDisplay = computed({
    get: () => formatDateForDisplay(searchConditionReceptionDateFrom.value),
    set: (val: string | null) => {
      if (!val) searchConditionReceptionDateFrom.value = null;
    },
  });
  const searchConditionReceptionDateToDisplay = computed({
    get: () => formatDateForDisplay(searchConditionReceptionDateTo.value),
    set: (val: string | null) => {
      if (!val) searchConditionReceptionDateTo.value = null;
    },
  });
  const searchConditionDeliveryDateFromDisplay = computed({
    get: () => formatDateForDisplay(searchConditionDeliveryDateFrom.value),
    set: (val: string | null) => {
      if (!val) searchConditionDeliveryDateFrom.value = null;
    },
  });
  const searchConditionDeliveryDateToDisplay = computed({
    get: () => formatDateForDisplay(searchConditionDeliveryDateTo.value),
    set: (val: string | null) => {
      if (!val) searchConditionDeliveryDateTo.value = null;
    },
  });

  const onReceptionDateFromSelected = () => {
    ReceptionDateFrom.value = false;
  };
  const onReceptionDateToSelected = () => {
    ReceptionDateTo.value = false;
  };
  const onDeliveryDateFromSelected = () => {
    DeliveryDateFrom.value = false;
  };
  const onDeliveryDateToSelected = () => {
    DeliveryDateTo.value = false;
  };

  const clearReceptionDateFrom = () => {
    searchConditionReceptionDateFrom.value = null;
  };
  const clearReceptionDateTo = () => {
    searchConditionReceptionDateTo.value = null;
  };
  const clearDeliveryDateFrom = () => {
    searchConditionDeliveryDateFrom.value = null;
  };
  const clearDeliveryDateTo = () => {
    searchConditionDeliveryDateTo.value = null;
  };

  const statusSelectedItem = ref<string[] | number[]>([]);

  return {
    formatDateForDisplay,
    searchConditionReceptionNo,
    searchConditionMemberId,
    searchConditionName,
    searchConditionPhone,
    searchConditionZipCode,
    searchConditionRegisterNo,
    searchConditionReceiptNo,
    ReceptionDateFrom,
    ReceptionDateTo,
    DeliveryDateFrom,
    DeliveryDateTo,
    searchConditionReceptionDateFrom,
    searchConditionReceptionDateTo,
    searchConditionDeliveryDateFrom,
    searchConditionDeliveryDateTo,
    searchConditionReceptionDateFromDisplay,
    searchConditionReceptionDateToDisplay,
    searchConditionDeliveryDateFromDisplay,
    searchConditionDeliveryDateToDisplay,
    onReceptionDateFromSelected,
    onReceptionDateToSelected,
    onDeliveryDateFromSelected,
    onDeliveryDateToSelected,
    clearReceptionDateFrom,
    clearReceptionDateTo,
    clearDeliveryDateFrom,
    clearDeliveryDateTo,
    statusSelectedItem,
  };
};
